import { useLoanContracts } from './hook/useLoanContracts';
import { GenericTable } from '../../../components/ui/Table'

const LoanContracts = () => {
  const {
    columns,
    loan
  } = useLoanContracts();

  return (
    <GenericTable
      columns={columns}
      data={loan}
      rowsPerPage={10}
    />
  )
}

export default LoanContracts